module.exports = __webpack_public_path__ + "img/USA_VEGETABLE_OILS.b2cc329e.png";